import script from "./AppImg.vue?vue&type=script&setup=true&lang=js"
export * from "./AppImg.vue?vue&type=script&setup=true&lang=js"

import "./AppImg.vue?vue&type=style&index=0&id=32f567b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32f567b6"]])

export default __exports__